import { useRef } from 'react';
import "@/App.css";
import { AppProvider } from './context/AppContext';
import {
  Header,
  HeroSection,
  CalculatorInputs,
  ResultsDisplay,
  InvestmentChart,
  BreakdownTable,
  StrategyComparison,
} from './components/calculator';
import { Toaster } from './components/ui/sonner';

const CalculatorApp = () => {
  const calculatorRef = useRef(null);

  const scrollToCalculator = () => {
    calculatorRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <HeroSection onScrollToCalculator={scrollToCalculator} />

      <main
        ref={calculatorRef}
        className="max-w-7xl mx-auto px-4 sm:px-6 pb-24"
        data-testid="calculator-section"
      >
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          <div className="lg:col-span-4 space-y-6">
            <CalculatorInputs />
          </div>
          <div className="lg:col-span-8 space-y-6">
            <ResultsDisplay />
            <InvestmentChart />
          </div>
        </div>

        <div className="mt-8">
          <StrategyComparison />
        </div>

        <div className="mt-8">
          <BreakdownTable />
        </div>

        {/* Footer */}
        <footer className="mt-16 pt-8 border-t border-border">
          <div className="text-center text-sm text-muted-foreground space-y-2">
            <p className="font-medium text-foreground/80">
              Calculator dobândă compusă — Instrument informativ pentru planificarea financiară
            </p>
            <p className="text-xs">
              Acest calculator oferă estimări și nu constituie sfat financiar sau fiscal profesionist.
            </p>
            <div className="pt-2 text-xs space-y-1">
              <p>
                © 2026{' '}
                <a href="https://moneysmart.ro/" target="_blank" rel="noopener noreferrer" className="text-blue-600 dark:text-blue-400 hover:underline font-medium">
                  MoneySmart.ro
                </a>{' '}
                — Toate drepturile rezervate
              </p>
              <p className="text-muted-foreground/70">
                Powered by{' '}
                <a href="https://darkoweb.ro/" target="_blank" rel="noopener noreferrer" className="hover:underline text-muted-foreground">
                  DarkoWeb
                </a>{' '}
                • Optimized by{' '}
                <a href="https://prowebit.ro/" target="_blank" rel="noopener noreferrer" className="hover:underline text-muted-foreground">
                  ProWebIT
                </a>
              </p>
            </div>
          </div>
        </footer>
      </main>

      <Toaster />
    </div>
  );
};

function App() {
  return (
    <AppProvider>
      <CalculatorApp />
    </AppProvider>
  );
}

export default App;
